// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { getStorage } from "firebase/storage";

// after initializing your Firebase app





// ✅ Use your actual Firebase config here
const firebaseConfig = {
    apiKey: "AIzaSyAwJOW8LUIyIm4nVJCxH7AQi_MfvtCk_3Q",
    authDomain: "brainy-buddy-game.firebaseapp.com",
    projectId: "brainy-buddy-game",
    storageBucket: "brainy-buddy-game.firebasestorage.app",
    messagingSenderId: "221342396053",
    appId: "1:221342396053:web:9d308f8130c0431ac3b59c",
    measurementId: "G-D9P8KD44GV"
  };

const app = initializeApp(firebaseConfig);

// ✅ This part is most important:
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };

